import { useState } from 'react'

/**
 * Hook for managing dynamic page titles in the header
 */
export function usePageTitle() {
  const [pageTitle, setPageTitle] = useState<string>('Dashboard')
  const [breadcrumb, setBreadcrumb] = useState<string[]>([])

  return {
    pageTitle,
    breadcrumb,
    setPageTitle,
    setBreadcrumb,
    setFullTitle: (title: string, breadcrumbs: string[] = []) => {
      setPageTitle(title)
      setBreadcrumb(breadcrumbs)
    },
  }
}

// Global page title state (singleton pattern)
let globalPageTitle = 'Dashboard'
let globalBreadcrumb: string[] = []
let titleUpdateCallback:
  ((title: string, breadcrumb: string[]) => void) | null = null

export const PageTitleService = {
  setTitle: (title: string, breadcrumb: string[] = []) => {
    globalPageTitle = title
    globalBreadcrumb = breadcrumb
    document.title = `${title} | MDi Optimus`
    titleUpdateCallback?.(title, breadcrumb)
  },

  getTitle: () => globalPageTitle,
  getBreadcrumb: () => globalBreadcrumb,

  subscribe: (callback: (title: string, breadcrumb: string[]) => void) => {
    titleUpdateCallback = callback
    // Send current state immediately
    callback(globalPageTitle, globalBreadcrumb)

    return () => {
      titleUpdateCallback = null
    }
  },
}
